<template>
  <div class="flex-col">
    <b-tabs type="is-boxed" v-model="mainActiveTab">

      <b-tab-item>
        <template slot="header">
          <b-icon pack="fas" icon="tasks"></b-icon>
          <span> {{ $t('information_by_group') }} </span>
        </template>
        <div>

          <div class="flex">
            <div class="flex w-7/8">
              <treeselect
                :options="options"
                :show-count="true"
                :flatten-search-results="true"
                :placeholder="$t('select_group_menu')"
                :normalizer="normalizer"
                @input="handleSelectGroup"
              />

              <b-tooltip :label="txtTooltipExport || this.$t('export')" position="is-left">
                <div class="rounded-full bg-blue w-8 h-8 flex ml-3 items-center justify-center text-grey-lightest cursor-pointer" @click="exportReport">
                  <b-icon icon="download" pack="fas" size="is-small" v-if="! isLoadingExport" />
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-spin"
                    v-if="isLoadingExport"
                    >
                  </b-icon>
                </div>
              </b-tooltip>
            </div>

            <div class="flex w-1/8 pl-2">
              <excel-by-activity-groups  :openWithButton="false"/>
            </div>
          </div>

          <!-- Panel 2 -->
          <div class="w-full mt-4 panel">
            <!-- <div class="flex flex-row w-full text-black font-bold justify-end text-xs">
              <div>{{ $t('last_update') }}: {{ formatDate() }}</div>
            </div> Este panel ya no se cachea -->
            <div class="flex flex-row w-full text-blue font-bold">{{ $t('group_progress') }}</div>
            <div class="flex flex-row w-full"><column-chart :data="panel2" suffix="%" :min="0" :max="100"/></div>
          </div>

          <!-- Panel presupuesto / valor ganado por grupos -->
          <dashboard-subpanel-budget v-if="project && project.id && company.alias === 'elecnor1'"
            :project-id="project.id" class="w-full mt-8"
          />

          <!-- Panel progreso semanal por grupo -->
          <dashboard-subpanel-man-hour v-if="project && project.id && company.alias === 'elecnor1'"
            :project-id="project.id" class="w-full mt-8"
          />

          <!-- Subpanel recursos por estructura de etiquetas -->
          <dashboard-subpanel-resource-executions
            v-if="project && project.id && company.alias === 'eag'"
            :project-id="project.id"
            :project-name="project.name"
            :currency="project.currency"
            class="w-full mt-8"
          />

          <!-- Gráficas dinámicas por grupo (con sub-grupos expandibles) -->
          <div class="w-full mt-8" v-for="group in panel3" :key="'panel3_'+(group.id || group.name)">
            <group-progress-chart
              :group="group"
              :level="0"
              :max-depth="10"
              :main-chart-colors="lineChartColors(group.withActualProgress)"
              :show-predicted-end-date="true"
              :fetch-children="fetchPanel3Children"
            />
          </div>

          <div v-if="isLoading" class="text-center my-4">
            <scale-loader></scale-loader>
          </div>

        </div>


      </b-tab-item>

      <b-tab-item v-if="project && project.id && ['eag', 'demoiberdrola'].includes(company.alias)">
        <template slot="header">
          <b-icon pack="fas" icon="tags"></b-icon>
          <span> {{ $t('information_by_tags') }} </span>
        </template>
        <dashboard-tags-scurve :project-id="project.id" />
      </b-tab-item>

      <b-tab-item>
        <template slot="header">
          <b-icon pack="fas" icon="tasks"></b-icon>
          <span> {{ $t('project_information') }}</span>
        </template>
        <project-information-panel :panel1="panel1" :export-filename="project.name + '_' + $t('information_per_user')" />
      </b-tab-item>

    </b-tabs>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
  import VueChartkick from 'vue-chartkick'
  import Chart from 'chart.js'
  import moment from 'moment'
  import excelByActivityGroups from '·/components/reports/excel-by-activity-groups.vue'
  import ProjectInformationPanel from '·/components/dashboard/project-information-panel.vue'
  import GroupProgressChart from '·/components/dashboard/group-progress-chart.vue'
  import DashboardSubpanelBudget from '·/components/dashboard/dashboard-subpanel-budget.vue'
  import DashboardSubpanelManHour from '·/components/dashboard/dashboard-subpanel-man-hour.vue'
  import DashboardSubpanelResourceExecutions from '·/components/dashboard/dashboard-subpanel-resource-executions.vue'
  import DashboardTagsScurve from '·/components/dashboard/dashboard-tags-scurve.vue'

  // import the component
  import Treeselect from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  Vue.use(VueChartkick, {adapter: Chart})

  export default {
    middleware: 'auth',
    title: 'project_home_page_title',
    subtitle: 'project_home_page_subtitle',
    menuOption: '2-1',

    components: {
      ScaleLoader,
      Treeselect,
      excelByActivityGroups,
      ProjectInformationPanel,
      GroupProgressChart,
      DashboardSubpanelBudget,
      DashboardSubpanelManHour,
      DashboardSubpanelResourceExecutions,
      DashboardTagsScurve,
    },

    data: () => ({
      filters: {
        location_id: 0,
        status_id: 1,
        tag_name: '',
        parent_group_id: null,
        baseline: '', // pasando vacio la linea azul Base Line mostrará ultima planificacion (fecha current_start/end_date de las actividades)
        // baseline: 'initial' // PARA TSK. pasando 'initial' la linea azul mostrará primera planificacion (fecha scheduled_start/end_date de las actividades) (seteado en mounted)
      },
      isLoading: true,
      panel1: {
        info: [],
        users: []
      },
      panel2: [],
      panel3: [],
      mainActiveTab: 0,
      options: [],
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          isDisabled: node.subgroups_num == 0,
          children: node.children,
        }
      },
      isLoadingExport: false,
      txtTooltipExport: null,
    }),

    computed: {
      ...mapGetters({
        company: 'app/company',
        project: 'app/project',
        user: 'auth/user',
      }),
    },

    mounted() {

      this.preparePanel1()
      if (this.project == null) {

        this.$router.push('/projects');

      } else {

        if (['tsk', 'eag'].includes(this.company.alias)) {
          this.filters.baseline = 'initial';
        }

        this.getActivityGroupsList()

        this.getPanel2();
        this.getPanel3();
        this.getPanel1();

        let pageInfo = {
          title: this.project.name,
          subtitle: this.$t('project_home_page_subtitle'),
          menuOption: '2-1',
        }

        this.$store.dispatch('app/updatePageInfo', {info: pageInfo})
      }
    },

    methods: {

      lineChartColors(withActualProgress) {
        // caso normal: azul (linea base), rojo (ejecutado), verde? (progreso real?), naranja (previsto)
        // con lineabase inicial: azul (linea base inicial), purple (linea base actual), rojo (ejecutado), verde? (progreso real?), naranja (previsto)
        let chartColors = ['#284ec0'] // blue
        if (this.filters.baseline == 'initial') {
          chartColors.push('#8c1a94') // purple
        }
        chartColors.push('#d12411') // red
        if (withActualProgress) {
          chartColors.push('#449431') // green
        }
        chartColors.push('#fc8608') // orange
        return chartColors
      },

      preparePanel1() {
        this.panel1.info = [
          {
            "name": this.$t('activity').toUpperCase(),
            "total": 0
          },
          {
            "name": this.$t('measurements_loaded').toUpperCase(), // "MEDICIONES CREADAS",
            "total": 0
          },
          {
            "name": this.$t('issues').toUpperCase(),
            "total": 0
          },
          {
            "name": this.$t('flows_created').toUpperCase(), // "FLUJOS CREADOS",
            "total": 0
          },
          {
            "name": this.$t('uploaded_images').toUpperCase(), // "IMÁGENES CARGADAS",
            "total": 0
          },
          {
            "name": this.$t('uploaded_documents').toUpperCase(), // "DOCUMENTOS CARGADOS",
            "total": 0
          },
          {
            "name": this.$t('comments').toUpperCase(),
            "total": 0
          }
        ]
      },

      handleSelectGroup(value, instanceId) {
        this.filters.parent_group_id = value ?? null

        this.isLoading = true
        this.getPanel2()
        this.panel3 = []
        this.getPanel3()
      },

      async getActivityGroupsList(args = []) {

        const {data} = await axios.get(`/api/v2/project/${this.project.id}/activity/groups`, {params: args});

        if (data && data.groups) {
          this.options = data.groups;
        } else {
          this.$notify.error('error_loading_activities')
        }
      },

      async getPanel1() {
        let self = this
        let url = '/api/v2/project/' + this.project.id + '/dashboard/photovoltaicpanel1';
        await axios.get(url, {params: this.filters})
          .then(response => {
            self.panel1 = response.data.data
          })
          .catch((error) => {
            self.$notify.error(error.error_msg || 'error_retrieving_data')
          });
      },

      async getPanel2() {
        let self = this
        let url = '/api/v2/project/' + this.project.id + '/dashboard/photovoltaicpanel2';
        await axios.get(url, {params: this.filters})
          .then(response => {
            self.panel2 = response.data.data
          })
          .catch((error) => {
            self.$notify.error(error.error_msg || 'error_retrieving_data')
          });
      },

      async getPanel3() {
        let self = this
        // estos proyectos llevan otro tipo de prediccion
        if( ['elecnor1'].includes(this.company.alias)) {
          this.filters['predictionType'] = 'spi'
        }
        let url = '/api/v2/project/' + this.project.id + '/dashboard/photovoltaicpanel3';
        await axios.get(url, {params: this.filters})
          .then(response => {
            self.isLoading = false;
            self.panel3 = response.data.data
          })
          .catch((error) => {
            self.$notify.error(error.error_msg || 'error_retrieving_data')
          });
      },

      // Lazy-load de sub-grupos al expandir un grupo en group-progress-chart.
      // photovoltaicpanel3 ya acepta parent_group_id y devuelve todos los hijos en una sola llamada.
      async fetchPanel3Children(parentId) {
        const params = { ...this.filters, parent_group_id: parentId }
        try {
          const { data } = await axios.get('/api/v2/project/' + this.project.id + '/dashboard/photovoltaicpanel3', { params })
          return Array.isArray(data.data) ? data.data : []
        } catch (error) {
          this.$notify.error(error.error_msg || 'error_retrieving_data')
          return []
        }
      },

      formatDate(date) {
        return moment(date).format('HH:mm (DD-MM)'); //'DD-MM-YYYY HH:mm'
      },

      async exportReport() {

        if( !this.isLoadingExport ){
          this.txtTooltipExport = this.$t('generating');

          this.$notify.success('generating_report');
          this.isLoadingExport = true;
          let self = this
          let url = '/api/v2/project/' + this.project.id + '/dashboard/exportphotovoltaic';
          await axios.get(url, {params: this.filters})
            .then(response => {
              window.open(response.data.data);

              self.$notify.success('report_generated')
              self.isLoadingExport = false;
              self.txtTooltipExport = this.$t('export')
            })
            .catch((error) => {
              //Se produjo un error
              console.log("Error loading exportación")
              self.$notify.error(error.error_msg || 'error_retrieving_data')
              self.isLoadingExport = false
              self.txtTooltipExport = this.$t('export')
            });
        }
      },
    },

  };
  </script>
